<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
    >
        <path
            d="M16.3889 2.77778C16.8491 2.77778 17.2222 2.40469 17.2222 1.94445C17.2222 1.48421 16.8491 1.11111 16.3889 1.11111C15.9286 1.11111 15.5555 1.48421 15.5555 1.94445C15.5555 2.40469 15.9286 2.77778 16.3889 2.77778Z"
            fill="#8E8E93"
        />
        <path
            d="M4.29888 2.10444L3.24666 1.75444L2.89666 0.70222C2.78222 0.36222 2.22 0.36222 2.10555 0.70222L1.75555 1.75444L0.703329 2.10444C0.533329 2.16111 0.418884 2.32 0.418884 2.5C0.418884 2.68 0.53444 2.83889 0.703329 2.89555L1.75555 3.24555L2.10555 4.29778C2.16222 4.46777 2.32111 4.58222 2.50111 4.58222C2.68111 4.58222 2.84 4.46666 2.89666 4.29778L3.24666 3.24555L4.29888 2.89555C4.46888 2.83889 4.58333 2.68 4.58333 2.5C4.58333 2.32 4.46777 2.16111 4.29888 2.10444Z"
            fill="#8E8E93"
        />
        <path
            d="M5.80335 6.13999C5.79002 6.01221 5.78668 5.89999 5.78668 5.76888C5.78668 3.67221 7.48668 1.97221 9.58335 1.97221C11.3333 1.97221 12.8067 3.15666 13.2467 4.76777"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.62774 9.88222C4.62663 10.0644 2.40441 9.62444 2.24552 8.69333C2.03774 7.47778 5.42441 5.88556 9.80997 5.13667C14.1955 4.38778 17.9189 4.76556 18.1266 5.98111C18.2944 6.96556 16.1022 8.19778 12.9311 9.02889"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.78446 8.54333L6.66669 18.0556"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.2222 7.77777L18.0556 18.0555"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.0624 8.5012C11.287 8.28707 12.2527 7.95863 12.2194 7.76761C12.186 7.5766 11.1661 7.59534 9.94141 7.80948C8.71673 8.02361 7.75101 8.35205 7.78441 8.54307C7.81781 8.73408 8.83768 8.71534 10.0624 8.5012Z"
            fill="#8E8E93"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
